import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })

export class ScrollHandleService {

  private scrolledBottomValue: Subject<boolean>;
  private backToTopValue: Subject<boolean>;

  constructor() {
    this.scrolledBottomValue = new Subject();
    this.backToTopValue = new Subject();
  }

  setScrolledBottomValue(value: boolean = true) {
    this.scrolledBottomValue.next(value);
  }

  getScrolledBottomValue(): Observable<boolean> {
    return this.scrolledBottomValue.asObservable();
  }

  setBackToTopValue(value: boolean = true) {
    this.backToTopValue.next(value);
  }

  getBackToTopValue(): Observable<boolean> {
    return this.backToTopValue.asObservable();
  }
}
